


























































// @ts-nocheck
import Vue from 'vue';
import { DetailStore, PayDialogStore } from '@/store/index';
import { FitButton } from '@/fit-ui';
import PayDialog from '@/components/PayDialog.vue';
import TencentCharityTips from '@/components/TencentCharityTips.vue';
import { biHottag } from '@tencent/ppd-base-libs';
import { isTencentCharityProject, isDapuFireMourning } from '@/business/helper';
import GongyiDetail from '@/components/GongyiDetail.vue';
import sdk from '@/business/sdk';
import { getOrganByOid } from '@/business/cfg';
import { formatTimeToChinese } from '@/utils/index';
import { showLoading, hideLoading } from '@/fit-components/loading/main';

export default Vue.extend({
  name: 'detail',
  data() {
    return {
      tencentCharity: false,
      DetailStore,
      organ: {},
      endTime: '',
    };
  },
  activated() {
    this.tencentCharity = isTencentCharityProject(DetailStore.isNineProj);

    this.organ = getOrganByOid(this.DetailStore.oid);

    this.endTime = formatTimeToChinese(this.DetailStore.endTime);

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);
    PayDialogStore.amount = '';
    PayDialogStore.need_receipt = '1';
    PayDialogStore.inputAmount = '';
    PayDialogStore.isUsePreset = true;
    PayDialogStore.selectedLevel = 1;
    biHottag('wallet.charity.detail.view', {
      fcharity_project: sessionStorage.getItem('pid'),
      fcharity_organization: sessionStorage.getItem('oid'),
    });
    this.shareInit();
  },
  deactivated() {
    PayDialogStore.show = false;
  },
  methods: {
    getLogoStyle(url: string) {
      return {
        backgroundSize: '100% 100%',
        backgroundImage: `url(${url})`,
      };
    },
    handleClickConfirm() {
      PayDialogStore.show = true;
      biHottag('wallet.charity.detail.click', {
        fcharity_project: sessionStorage.getItem('pid'),
        fcharity_organization: sessionStorage.getItem('oid'),
      });
    },
    showTencentTips() {
      biHottag('wallet.charity.detail.redbanner_click');
      DetailStore.tencentCharityTipsShow = true;
    },
    shareInit() {
      sdk.share({
        url: `https://apps.wechatpay.com.hk/charity/index.shtml?pid=${this.DetailStore.pid}&ADTAG=share`,
        desc: this.DetailStore.desc,
        title: this.DetailStore.title,
        imgUrl: this.tencentCharity
          ? 'https://st.moneydata.hk/res/fmd_mojo_static/0ZA1aCIRgRo9YzgB1piHSXyGyj9Oopyp.png'
          : (isDapuFireMourning() ? 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20251127211015/icon.png' : 'https://st.moneydata.hk/res/fmd_mojo_static/MnU8oCJODOUZXNjxf6fmaRoLCMiwNaqK.png'),
      });
    },
  },
  components: {
    FitButton,
    PayDialog,
    TencentCharityTips,
    GongyiDetail,
  },
  created() {
    if (!this.DetailStore.title) {
      this.$router.replace('/');
    }
  },
});
